import React, { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../../firebase';
import StudentGradesModal from './StudentGradesModal';

const StudentList = ({
  students,
  removeStudent,
  selectedStudent,
  setSelectedStudent,
  sessions,
  classId,
  theme,
}) => {
  const [grades, setGrades] = useState({});
  const [studentSearchTerm, setStudentSearchTerm] = useState('');

  useEffect(() => {
    const fetchGrades = async () => {
      try {
        const gradesDocRef = doc(db, 'grades', classId);
        const gradesDocSnap = await getDoc(gradesDocRef);
        if (gradesDocSnap.exists()) {
          setGrades(gradesDocSnap.data());
        } else {
          console.log('No grades data found');
        }
      } catch (error) {
        console.error('Error fetching grades:', error);
      }
    };

    fetchGrades();
  }, [classId]);

  const handleStudentSearch = (e) => {
    setStudentSearchTerm(e.target.value);
  };

  const filteredStudents = students.filter((student) =>
    `${student.firstName} ${student.lastName}`
      .toLowerCase()
      .includes(studentSearchTerm.toLowerCase())
  );

  const viewStudentGrades = (student) => {
    setSelectedStudent(student);
  };

  const closeStudentGrades = () => {
    setSelectedStudent(null);
  };

  useEffect(() => {
    if (selectedStudent) {
      window.scrollTo(0, 0);
    }
  }, [selectedStudent]);

  return (
    <div
      className="w-full min-w-0 p-3 sm:p-4 rounded shadow-md"
      style={{
        backgroundColor: 'var(--section-bg)',
        color: 'var(--text-color)',
      }}
    >
      <h3 className="text-xl font-semibold mb-4">Students</h3>
      <div className="mb-4">
        <input
          type="text"
          placeholder="Search Students..."
          value={studentSearchTerm}
          onChange={handleStudentSearch}
          className="w-full max-w-md p-2 border border-[var(--muted-color)] rounded bg-[var(--card-bg)] text-[var(--text-color)] focus:outline-none focus:ring-2 focus:ring-[var(--primary-color)]
                           focus:border-transparent transition-all"
          style={{
            backgroundColor: 'var(--card-bg)',
            color: 'var(--text-color)',
            borderColor: 'var(--muted-color)',
          }}
        />
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200" style={{ color: 'var(--text-color)' }}>
          <thead className="bg-gray-100" style={{ backgroundColor: 'var(--card-hover-bg)' }}>
            <tr>
              <th className="px-4 py-2 text-left text-sm font-medium" style={{ color: 'var(--text-color)' }}>Name</th>
              <th className="px-4 py-2 text-left text-sm font-medium" style={{ color: 'var(--text-color)' }}>Email</th>
              <th className="px-4 py-2 text-left text-sm font-medium" style={{ color: 'var(--text-color)' }}>Total Points</th>
              <th className="px-4 py-2 text-left text-sm font-medium" style={{ color: 'var(--text-color)' }}>Action</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {filteredStudents.map((student) => {
              const studentGrades = grades.students?.[student.uid] || {};
              const totalPoints = Object.values(studentGrades).reduce(
                (sum, session) =>
                  sum + Object.values(session.points || {}).reduce((s, p) => s + p, 0),
                0
              );
              return (
                <tr
                  key={student.uid}
                  className="hover:bg-gray-50"
                  style={{ backgroundColor: 'var(--card-bg)' }}
                >
                  <td className="px-4 py-2">
                    {student.firstName} {student.lastName}
                  </td>
                  <td className="px-4 py-2">{student.email}</td>
                  <td className="px-4 py-2">{totalPoints.toFixed(2)}</td>
                  <td className="px-4 py-2 space-x-2">
                    <button
                      onClick={() => viewStudentGrades(student)}
                      className="px-3 py-1 rounded transition-colors"
                      style={{
                        backgroundColor: 'var(--primary-color)',
                        color: 'var(--nav-active-text)',
                      }}
                      onMouseOver={(e) =>
                        (e.currentTarget.style.backgroundColor = 'var(--hover-color)')
                      }
                      onMouseOut={(e) =>
                        (e.currentTarget.style.backgroundColor = 'var(--primary-color)')
                      }
                    >
                      View Grades
                    </button>
                    <button
                      onClick={() => removeStudent(student.uid)}
                      className="px-3 py-1 rounded transition-colors"
                      style={{
                        backgroundColor: 'var(--primary-color)',
                        color: 'var(--nav-active-text)',
                      }}
                      onMouseOver={(e) =>
                        (e.currentTarget.style.backgroundColor = 'var(--hover-color)')
                      }
                      onMouseOut={(e) =>
                        (e.currentTarget.style.backgroundColor = 'var(--primary-color)')
                      }
                    >
                      Remove
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {selectedStudent && (
        <StudentGradesModal
          student={selectedStudent}
          gradesData={grades}
          sessionsData={sessions}
          closeModal={closeStudentGrades}
          classId={classId}
          theme={theme}
        />
      )}
    </div>
  );
};

export default StudentList;
